module.exports = __webpack_public_path__ + "img/MO.e7460625.png";